import axios from "axios";
import wx from "weixin-js-sdk";
export function wxInit() {
  axios({
    url: import.meta.env.VITE_API_BASE_URL + "/user/wechat/share.html",
    method: "get",
    params: {
      url: location.href.split("#")[0],
    },
  }).then((res) => {
    const data = JSON.parse(res.data.data);
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: data.jsApiList,
      openTagList: ["wx-open-launch-weapp"], //微信开放标签
    });
  });
}
export function wxShare(shareTitle, shareSummary, shareImg, shareLink) {

  wx.ready(function () {
    //分享到朋友圈
    wx.updateAppMessageShareData({
      title: shareTitle, // 分享时的标题
      desc: shareSummary,
      link: shareLink, // 分享时的链接
      imgUrl: shareImg, // 分享时的图标
      success: function () {
        console.log("分享成功");
      },
      cancel: function () {
        console.log("取消分享");
      },
    });
    //分享给朋友
    wx.updateTimelineShareData({
      title: shareTitle,
      link: shareLink,
      imgUrl: shareImg,
      success: function () {
        console.log("分享成功");
      },
      cancel: function () {
        console.log("取消分享");
      },
    });
  });
}
//微信支付
export function wxPay(timeStamp, nonceStr, packAge, signType, paySign, suc, err) {
  wx.ready(() => {
    wx.chooseWXPay({
      timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
      package: packAge, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      signType: signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
      paySign: paySign, // 支付签名
      success: function (res2) {
        // 支付成功后的回调函数
        suc();
      },
      cancel: function (res3) {
        err();
      },
    });
  });
}
//打开微信内置地图
export function openLocation(latitude, longitude, name, address) {
  console.log(latitude, longitude);
  wx.ready(function () {
    wx.openLocation({
      latitude: Number(latitude), // 纬度，浮点数，范围为90 ~ -90
      longitude: Number(longitude), // 经度，浮点数，范围为180 ~ -180。
      name: name, // 位置名
      address: address, // 地址详情说明
      scale: 12, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
    });
  });
}
/**
 * 开放标签 打开小程序
 * @param {*} info
 * @returns
 */
export function wx_launch_weapp(info) {
  if (!is_weixn()) {
    return;
  }
  if (is_version()) {
    var btn = document.getElementById(info.eleId); //获取元素
    let script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
    script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
    script.text = info.content; // 自定义的html字符串内容
    let html = `<wx-open-launch-weapp style="width:100%;display:block;" username="${info.appid}" path="${info.url}">${script.outerHTML}</wx-open-launch-weapp>`;
    btn.innerHTML = html; // html字符串赋值
    // 点击按钮 正常跳转触发
    btn.addEventListener("launch", function (e) {
      console.log("success");
    });
    // 点击跳转 抛出异常
    btn.addEventListener("error", function (e) {
      console.log("fail", e.detail);
    });
  } else {
  }
}

// 判断是否微信环境
function is_weixn() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

// 判断当前微信版本号是否支持
function is_version() {
  let client = false; // 当前版本号是否支持 (默认不支持)
  let wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
  if (wxInfo == null) {
    return client;
  } else {
    // 微信版本号 wxInfo[1] = "7.0.18.1740" (示例)
    //进行split转成数组进行判断 [7,0,18,1740] (示例)
    let version = wxInfo[1].split(".");
    // 判断版本在7.0.12及以上的版本
    if (version[0] >= 7) {
      if (version[1] >= 0) {
        if (version[2] >= 12) {
          client = true; // 当前版本支持
        }
      }
    }
    if (version[0] >= 8) {
      client = true;
    }
    return client;
  }
}
/**
 * 在常观打开此页
 * @param {*} url
 */
export function openCgApp(url) {
  window.location.href = "https://sharekcz.cztv.tv/openApp?redirect_url=" + encodeURIComponent(url);
}
